import React from 'react';
import styled from 'styled-components';
import PrimaryButton from 'web-ui-kit/buttons/PrimaryButton';
import SecondaryButton from 'web-ui-kit/buttons/SecondaryButton';
import { backgroundLightM } from 'web-ui-kit/colors';
import Dropdown, { styles as styles$1 } from 'web-ui-kit/SelectionControls/Dropdown';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2; // function getQuantityOptions (quantityMultiple = 1) {
//   const MAX_OPTIONS = 30;
//   const qtyArr = [];
//   for (let i = quantityMultiple; i <= MAX_OPTIONS; i = i + quantityMultiple) {
//     qtyArr.push(i);
//   }
//   const quantityOptions = qtyArr.map(
//     qty => ({ label: qty.toString(), value: qty })
//   );
//   return quantityOptions;
// }

/**
 * CTA content block.
 */


function CTA(_ref) {
  var _ref$atcQuantity = _ref.atcQuantity,
      _ref$atcStatus = _ref.atcStatus,
      atcStatus = _ref$atcStatus === void 0 ? 'not-in-cart' : _ref$atcStatus,
      _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$mqSingleColumnBe = _ref.mqSingleColumnBelow,
      mqSingleColumnBelow = _ref$mqSingleColumnBe === void 0 ? '' : _ref$mqSingleColumnBe,
      _ref$product = _ref.product,
      product = _ref$product === void 0 ? {} : _ref$product,
      _ref$swapStatus = _ref.swapStatus,
      swapStatus = _ref$swapStatus === void 0 ? 'unavailable' : _ref$swapStatus,
      _ref$quantityMultiple = _ref.quantityMultiple; // uiMessaging gql is wrapped in FF, and contains the latest product CTA messaging.

  var _ref2 = product.availabilityV2 || {},
      _ref2$status = _ref2.status,
      status = _ref2$status === void 0 ? '' : _ref2$status;

  var _ref3 = product.uiMessaging || {},
      _ref3$ctaTitle = _ref3.ctaTitle,
      ctaTitle = _ref3$ctaTitle === void 0 ? '' : _ref3$ctaTitle;

  var retailerUrl = (product === null || product === void 0 ? void 0 : product.retailerUrl) || '';
  var statusOutOfStock = ctaTitle ? ctaTitle === 'Currently Unavailable' : status === 'OUT_OF_STOCK';
  var statusDiscontinued = ctaTitle ? ctaTitle === 'Discontinued' : status === 'DISCONTINUED';
  var isUnavailable = statusOutOfStock || statusDiscontinued;
  var initialButtonText = '';

  if (statusOutOfStock) {
    initialButtonText = ctaTitle || 'Currently Unavailable';
  } else if (statusDiscontinued) {
    initialButtonText = ctaTitle || 'Discontinued';
  } else if (retailerUrl) {
    initialButtonText = 'View Full Product Details';
  } else {
    initialButtonText = 'Currently Unavailable';
  }

  var ctaButtonText = initialButtonText;
  var atcDisabled = atcStatus === 'adding-to-cart' || atcStatus === 'added-to-cart' || statusOutOfStock || statusDiscontinued || disabled;
  var showSwapButton = (swapStatus === 'available' || swapStatus === 'in-progress' || swapStatus === 'in-progress-active') && !disabled;
  var swapButtonDisabled = swapStatus === 'in-progress' || swapStatus === 'in-progress-active';

  var handlePrimaryCtaClick = function handlePrimaryCtaClick(event) {
    var _event$payload;

    if (!(event !== null && event !== void 0 && (_event$payload = event.payload) !== null && _event$payload !== void 0 && _event$payload.disabled) && retailerUrl) {
      // MODSY WIND DOWN.
      // LINK OUT TO THE RETAILER UI WHEN AVAILABLE
      window.open(retailerUrl, '_blank');
    }
  }; // const QUANTITY_OPTIONS = getQuantityOptions(quantityMultiple);


  var Container = styles.Container;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      "data-testid": "cta",
      isUnavailable: !isUnavailable,
      mqSingleColumnBelow: mqSingleColumnBelow,
      swapEnabled: showSwapButton
    },
    /*#__PURE__*/
    React.createElement(PrimaryButton, {
      disabled: atcDisabled,
      dispatch: handlePrimaryCtaClick,
      fluid: true,
      id: "atc" // Icon={atcStatus === 'added-to-cart' ? <CheckIcon variant={'primary'} size={24} /> : null}
      ,
      labelText: ctaButtonText,
      size: "medium"
    }), showSwapButton &&
    /*#__PURE__*/
    React.createElement(SecondaryButton, {
      dispatch: dispatch,
      disabled: swapButtonDisabled,
      fluid: true,
      id: "swap",
      labelText: copy.swap[swapStatus],
      size: "medium"
    }))
  );
}

var copy = {
  atc: {
    'not-in-cart': 'Add to Cart',
    'adding-to-cart': 'Adding to Cart...',
    'added-to-cart': 'Added to Cart',
    'buy-from-retailer': 'Buy from Retailer'
  },
  swap: {
    available: 'Swap',
    'in-progress': 'Swap',
    'in-progress-active': 'Swapping In'
  }
};
var styles = {
  Container: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: 1fr ", ";\n    grid-column-gap: 0.5rem;\n\n    padding-bottom: 1.5rem;\n\n    /** For single column layout, the CTA content block is fixed\n     * to the bottom of product details comonent\n     */\n    ", " {\n      position: fixed;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      z-index: 1;\n\n      background-color: ", ";\n      box-sizing: border-box;\n      padding: 0.5rem 1rem;\n    };\n\n    /**\n     * \"Discontinued\" and \"Currently Unavailable\" don't display the quantity dropdown.\n     * Disabled button is full-width.\n     */\n    // ", " {\n    //   display: block;\n    // }\n  "])), function (p) {
    return p.swapEnabled ? 'min-content' : '';
  }, function (p) {
    return p.mqSingleColumnBelow;
  }, backgroundLightM, function (p) {
    return p.isUnavailable;
  }),
  QuantityDropdown: styled(Dropdown)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    /** reduce button height to match medium CTAs */\n    padding-bottom: 0.8125rem;\n    padding-top: 0.8125rem;\n\n    ", " {\n      max-height: 15.125rem;\n\n      ", " {\n        top: unset;\n        bottom: calc(100% + 1px);\n      }\n    }\n  "])), styles$1.Menu, function (p) {
    return p.mqSingleColumnBelow;
  })
};
export default CTA;